'use strict';

/**
 * View for rrendering an image in the list
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/components/image-selection-list-item.hbs');

var ImageSelectionListItemView = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    className: function() {
        var className = ['box box-clean box-object-image'];

        if (this.model.get('restricted')) {
            className.push('is-restricted');
        }

        if (this.model.get('main')) {
            className.push('is-main');
        }

        if (this.model.get('uploading')) {
            className.push('is-uploading');
        }

        if (this.model.get('importing')) {
            className.push('is-importing');
        }

        return className.join(' ');
    },

    ui: {
        'removeImage': '[data-action="remove-image"]',
        'setAsMain': '.image',
    },

    events: {
        'click @ui.removeImage': 'removeImage',
        'click @ui.setAsMain': 'setAsMain',
    },

    modelEvents: {
        'change request sync': 'render',
    },

    /**
     * Event for handling remove
     * @param {object} event The event object
     * @return {void}
     */
    removeImage: function(event) {
        event.preventDefault();
        event.stopPropagation(); //@todo remove the crap out of this
        //this.model.destroy();
        this.model.collection.remove(this.model);
    },

    onRender: function() {
        var className = _.result(this, 'className');
        this.$el.removeClass().addClass(className);
    },

    /**
     * Event for handling main set
     * @param {object} event The event object
     * @return {void}
     */
    setAsMain: function(event) {
        event.preventDefault();
        if ($(event.currentTarget).parent().hasClass('is-restricted')) {
            return;
        }
        this.model.set('main', !this.model.get('main'));
    },
});

module.exports = ImageSelectionListItemView;